import { Suspense } from "react";
import { Outlet } from "react-router-dom";

import cls from "./AuthenticatedLayout.module.css";

import { Tutorial } from "@/features/tutorial";
import { Loader } from "@/shared/ui/Loader/Loader";
import { GdprConsentBanner } from "@/widgets/gdprConsent";
import { Header } from "@/widgets/Header";
import { SidebarLock } from "@/widgets/Sidebar/ui/Sidebar";

export const AuthenticatedLayout = () => {
    return (
        <>
            <Header />
            <div className={cls.layout}>
                <SidebarLock />
                <div className={cls.content}>
                    <Suspense fallback={<Loader />}>
                        <Outlet />
                    </Suspense>
                </div>
            </div>
            <GdprConsentBanner />
            <Tutorial />
        </>
    );
};
